module.exports = __webpack_public_path__ + "static/media/5.21308ea8.png";